export default __webpack_public_path__ + "5b2b0ed51b72f4d382e895a55d76e65b.svg";